import {useSelector} from 'react-redux'
import './index.scss'
import classNames from 'classnames'

const InputWithIcon = ({type, placeholder, value, onChange, onIconClick = () => {}, className, icon, name = ''}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    return (
        <>
            <input type={type} placeholder={placeholder} onChange={onChange} value={value}
                className={classNames('input-icon', {
                    [className]: !!className,
                    dark: isDarkMode
                })} name={name}/>
            <button className="icon" onClick={onIconClick}>{icon}</button>
        </>
    )
}

export default InputWithIcon
